"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHREventDrivenServer = void 0;
var XHREventDrivenServer_1 = require("./XHREventDrivenServer");
Object.defineProperty(exports, "XHREventDrivenServer", { enumerable: true, get: function () { return XHREventDrivenServer_1.XHREventDrivenServer; } });
//# sourceMappingURL=index.js.map